import useApiClient from '../../Base/Hooks/useApiClient';
import apiClient from '../../../Services/ApiClient';
import { Meta } from '../../../graphql/graphql';

export default function useMeta() {
	const { displayError } = useApiClient();

	const createUserMetaBulk = async ({
		userId,
		metaItems,
	}: {
		userId: string;
		metaItems: { key: string; value: string | boolean | number }[];
	}) => {
		try {
			return await apiClient.post(`/user/${userId}/meta/bulk`, {
				data: metaItems,
			});
		} catch (e) {
			displayError(e);
		}
	};

	const createUserMeta = async (
		userId: string,
		metaKey: string,
		metaValue: string | boolean | object,
	) => {
		try {
			const result: any = await apiClient.post(`/user/${userId}/meta/`, {
				key: metaKey,
				value: metaValue,
			});
			return result;
		} catch (e: any) {
			displayError(e);
		}
	};

	const createWorkplaceMeta = async ({
		workplaceId,
		meta,
	}: {
		workplaceId: string;
		meta: { key: string; value: string | boolean | number };
	}) => {
		try {
			const result: any = await apiClient.post(
				`/workplaces/${workplaceId}/meta/`,
				meta,
			);
			return result;
		} catch (e: any) {
			displayError(e);
		}
	};

	const getMetaAsObject = (meta: Meta[]) => {
		return Object.fromEntries(
			meta.map(({ key, value }) => {
				return [key, value];
			}),
		);
	};

	return {
		createUserMeta,
		createWorkplaceMeta,
		createUserMetaBulk,
		getMetaAsObject,
	};
}
